/**
 * Created by asiulik on 16.05.2017.
 */

define(['jquery', './finderConst', './finder'], function($, FinderConst, Finder){

    function Finders(){
    }

    Finders.prototype.init = function(layoutInstance) {

        var _this = this;

        this.$finders = $(FinderConst.finderSelector);
        this.layoutInstance = layoutInstance;
        this.finders = [];

        if(!this.$finders.length) return;

        [].forEach.call(this.$finders, function(finder) {

            var $finder = $(finder);
            var finderInstace = new Finder($finder, _this.layoutInstance);
            finderInstace.init();

            _this.finders.push(finderInstace);

        });
    };

    Finders.prototype.initFinder = function($content){

        var $finder = $content.find(FinderConst.finderInOvelaySelector);

        if(!$finder.length) return;
        if($finder.hasClass(FinderConst.finderInitedClass)) return;

        var finderInstace = new Finder($finder, this.layoutInstance);
        finderInstace.init();

        $finder.addClass(FinderConst.finderInitedClass);

        this.finders.push(finderInstace);

    };

    return Finders;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finders.js